import { J as JuiSkeletonLoader$1, d as defineCustomElement$1 } from './jui-skeleton-loader2.js';

const JuiSkeletonLoader = JuiSkeletonLoader$1;
const defineCustomElement = defineCustomElement$1;

export { JuiSkeletonLoader, defineCustomElement };

//# sourceMappingURL=jui-skeleton-loader.js.map